"use strict"

import axios from 'axios'

export const validateAccount = async (accountForm) => {
    const result = await axios.post(process.env.VUE_APP_API_BASE_URL + 'wecare_plus/activation-validate-account', accountForm)
    return result
}

export const activation = async (form) => {
    const result = await axios.post(process.env.VUE_APP_API_BASE_URL + 'wecare_plus/activation', form)
    return result
}